import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AuthLayout, AuthField, AuthError, SubmitButton, GoogleButton, useSubmitState } from "@/components/auth/AuthParts";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const set = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));
  const { error, loading, submit } = useSubmitState(async () => {
    await register(form.email, form.password, form.name);
    navigate("/dashboard");
  });

  const footer = <>Have an account? <Link to="/login" data-testid="back-to-login" className="link-blue">Log in →</Link></>;

  return (
    <AuthLayout title="Sign Up" testId="register-page" footer={footer}>
      <form onSubmit={submit} className="mt-6 border-2 border-black p-6 space-y-4 bg-white hard-shadow">
        <AuthField label="Name" testId="register-name" value={form.name} onChange={set("name")} />
        <AuthField label="Email" testId="register-email" type="email" value={form.email} onChange={set("email")} />
        <AuthField label="Password" testId="register-password" type="password" minLength={6} value={form.password} onChange={set("password")} />
        <AuthError testId="register-error" message={error} />
        <SubmitButton testId="register-submit" loading={loading}>Create Account</SubmitButton>
        <GoogleButton testId="google-register-btn" />
      </form>
    </AuthLayout>
  );
}
